import { render, staticRenderFns } from "./galaxsys.vue?vue&type=template&id=64609379&scoped=true"
import script from "./galaxsys.vue?vue&type=script&lang=js"
export * from "./galaxsys.vue?vue&type=script&lang=js"
import style0 from "./galaxsys.vue?vue&type=style&index=0&id=64609379&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64609379",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/galaxsys.vue
// module id = leEv
// module chunks = 0